import {colors} from '../../../constants'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            padding: {base: 0, lg: '42px 0'},
            color: 'black'
        },
        list: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            fontSize: '16px'
        },
        headingLink: {
            display: 'inline-flex'
        },
        heading: {
            fontSize: '18px',
            lineHeight: '22.21px',
            marginBottom: '13px',
            fontWeight: '400',
            fontFamily: 'Raleway, sans-serif'
        }
    },
    variants: {
        vertical: {
            listItem: {
                marginTop: '0px !important',
                fontSize: '16px',
                lineHeight: '21.47px',
                fontWeight: '300',
                color: colors.textLight
            }
        },
        horizontal: {
            listItem: {
                borderLeft: '1px solid',
                paddingLeft: 2,
                fontSize: '16px',
                lineHeight: '18.75px',
                fontWeight: '300',
                color: colors.textLight
            },
            listItemSx: {
                '&:first-of-type': {
                    borderLeft: 0,
                    paddingLeft: 0
                }
            }
        }
    },
    defaultProps: {
        variant: 'vertical'
    }
}
